jQuery(document).ready(function ($) {

	const industriesTabs = document.querySelectorAll('.anchors-list__item');
	let industriesTabsArray = [... industriesTabs];

	(function(){
		let speed = 2; // Скорость скролла.

		if (document.querySelector('.anchors-list')) {
			let scroll = document.querySelector('.anchors-list');
			let left = 0; // отпустили мышку - сохраняем положение скролла
			let drag = false;
			let coorX = 0; // нажали мышку - сохраняем координаты.

			scroll.addEventListener('mousedown', function(e) {
				drag = true;
				coorX = e.pageX - this.offsetLeft;
			});
			document.addEventListener('mouseup', function() {
				drag = false;
				left = scroll.scrollLeft;
			});
			scroll.addEventListener('mousemove', function(e) {
				if (drag) {
					this.scrollLeft = left - (e.pageX - this.offsetLeft - coorX)*speed;
				}
			});
		}

	})();


	$(document).on('click ', '.anchors-list', function (e) {

		const current = e.target;

		if (current.classList.contains('active')) {
			current.scrollIntoView({block: "start", behavior: "smooth"});
			return true;
		} else if (current.classList.contains('anchors-list__item')) {
			industriesTabs.forEach((elem)=>{
				if (elem.classList.contains('active')) {
					elem.classList.remove('active');
				}
			})
			current.classList.add('active');
			let tab_id = current.getAttribute('data-tab');

			let currentTab = $('#' + tab_id)[0];
			let topPosition = currentTab.offsetTop - 150;


			window.scroll({
				top: topPosition,
				behavior: 'smooth'
			});
		}

	});


	//function for fixe tabs
	function fixedAnchorTab() {
		const elem = document.querySelector('.tabs-anchor-section');
		const elemChild = document.querySelector('.tabs-anchor-content-container');
		let headerHeight = document.querySelector('.header').offsetHeight;

		const top = +elem.getBoundingClientRect().top + elem.querySelector('.center-title-wrapper').offsetHeight - headerHeight ;
		const bottom = elemChild.getBoundingClientRect().height + top;

		if (top < 0 && bottom > 0) {
			elem.querySelector('.tabs-anchor-container').classList.add('fixed-dropdown');
		} else  {
			if ( elem.querySelector('.tabs-anchor-container').classList.contains('fixed-dropdown') ) {
				elem.querySelector('.tabs-anchor-container').classList.remove('fixed-dropdown');
			}
		}

	}
	if (document.querySelector('.tabs-anchor-container')) {
		fixedAnchorTab();
		window.addEventListener('scroll', fixedAnchorTab);
	}


	//function for check active tabs
	function checkTab(industriesTabsArray, currentIndex) {
		industriesTabsArray.forEach((e)=>{
			e.classList.contains('active') ? e.classList.remove('active') : true;
			if(e.getAttribute("data-tab") == currentIndex) {
				e.classList.add('active');
				let position = $(e).offset();
				e.scrollIntoView({block: "nearest", inline:'nearest'});
			}
		})

	}
	
	//observer for big numbers
	const options2 = {
		root: null,
		rootMargin: '-40% 0px -40% 0px',
		threshold: 0,
	}
	const servicesList = document.querySelectorAll('.tab-content');
	const callback2 = function(entries, observer) {
		entries.forEach(entry => {
			let currentTab, currentNumber, currentId;

			if ( entry.isIntersecting ) {
				currentTab = entry.target;
				currentId = currentTab.getAttribute('id');
				checkTab(industriesTabsArray, currentId);

				currentNumber = currentTab.querySelector('.number');
				$(currentNumber).addClass('moving-number');
			} else {
				$(currentNumber).removeClass('moving-number');
			}
		})
	};
	const observer2 = new IntersectionObserver(callback2, options2);
	servicesList.forEach( item => {
		observer2.observe( item );
	})

});